const PERMISSIONS_KEYS = Object.freeze({
  BASIC: 'basic',
  ADVANCED: 'advanced',
});

export default PERMISSIONS_KEYS;
